import { ORDER_STATUS } from '~constants/orders';

export const DATE = '05/07/2020';
export const HOUR = '13:56:08';
export const TIMER = 1000;
export const MINUTES_ALERT = 11;
export const TEN_SECONDS = 10;
export const ORDER_PRINT_COUNT_TTL = 10080;

export const HUMANIZE_OPTIONS = {
  language: 'es',
  largest: 3,
  round: true,
  spacer: ' ',
  conjunction: '',
  serialComma: false,
  delimiter: ' ',
  units: ['d', 'h', 'm']
};

export const HUMANIZE_OPTIONS_MINUTES = {
  language: 'es',
  largest: 2,
  round: true,
  spacer: ' ',
  conjunction: '',
  serialComma: false,
  delimiter: ' ',
  units: ['m', 's']
};

export const ORDER_STATUS_COLORS = {
  [ORDER_STATUS.CANCELED]: 'red',
  [ORDER_STATUS.COMPLETED]: 'green'
};

export const MERCAT_CHANNEL = 'mercat';

export const TOOLTIP_KEYS = {
  cashPayed: 'cashPayed',
  cardPayed: 'cardPayed',
  externalDelivery: 'externalDelivery',
  pickUpDelivery: 'pickUpDelivery',
  noAlternatives: 'noAlternatives',
  changeDelivery: 'changeDelivery',
  assignDelivery: 'assignDelivery'
};
